<template>
  <el-container class="main-container">
    <!-- ==================== 侧边栏 ==================== -->
    <el-aside :width="iscollapse ? '64px' : '220px'" class="sidebar">
      <!-- Logo / 系统标题 -->
      <div class="sidebar-brand">
        <div class="brand-icon">
          <i class="el-icon-s-home"></i>
        </div>
        <transition name="fade">
          <h2 v-if="!iscollapse" class="brand-title">智慧养老</h2>
        </transition>
      </div>

      <!-- 用户信息 -->
      <div class="sidebar-user">
        <el-avatar :size="38" :src="userHead" class="user-avatar">
          {{ adminer ? adminer.charAt(0) : 'U' }}
        </el-avatar>
        <transition name="fade">
          <div v-if="!iscollapse" class="user-detail">
            <span class="user-name">{{ adminer || '管理员' }}</span>
          </div>
        </transition>
      </div>

      <!-- 分割线 -->
      <div class="sidebar-divider"></div>

      <!-- 菜单滚动区域 -->
      <el-scrollbar :native="false" class="sidebar-menu-wrap">
        <el-menu
          router
          :default-active="activeIndex"
          background-color="#001529"
          text-color="rgba(255,255,255,0.65)"
          :collapse="iscollapse"
          :collapse-transition="false"
          active-text-color="#fff"
          unique-opened
        >
          <menu-item v-for="item in menus" :key="item.id" :item="item" />
        </el-menu>
      </el-scrollbar>

      <!-- 折叠切换按钮 -->
      <div class="sidebar-toggle" :class="{ 'toggle-right': !iscollapse }" @click="toggleCollapse">
        <i :class="iscollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
      </div>
    </el-aside>

    <!-- ==================== 右侧主体 ==================== -->
    <el-container class="main-area">
      <!-- 顶部栏 -->
      <el-header height="auto" class="main-header">
        <!-- 面包屑 + 工具栏 -->
        <div class="header-bar">
          <el-breadcrumb v-if="breadcrumbs.length" separator-class="el-icon-arrow-right" class="header-breadcrumb">
            <transition-group name="breadcrumb" tag="span">
              <el-breadcrumb-item
                v-for="item in breadcrumbs"
                :key="item.path"
                :to="item.path"
              >
                {{ item.meta.title || item.name }}
              </el-breadcrumb-item>
            </transition-group>
          </el-breadcrumb>

          <div class="header-actions">
            <el-tooltip content="派车大屏" placement="bottom" :open-delay="400">
              <el-button @click="toCarLarge" icon="el-icon-truck" class="action-btn" circle />
            </el-tooltip>
            <el-tooltip content="数据大屏" placement="bottom" :open-delay="400">
              <el-button @click="toLarge" icon="el-icon-data-line" class="action-btn" circle />
            </el-tooltip>
            <el-tooltip content="全屏" placement="bottom" :open-delay="400">
              <el-button @click="extend" icon="el-icon-full-screen" class="action-btn" circle />
            </el-tooltip>
            <el-divider direction="vertical"></el-divider>
            <el-tooltip content="退出登录" placement="bottom" :open-delay="400">
              <el-button @click="logout" icon="el-icon-switch-button" class="action-btn logout-btn" circle />
            </el-tooltip>
          </div>
        </div>

        <!-- 页签 -->
        <div v-if="pageTabs.length" class="header-tabs">
          <el-tabs
            v-model="activeIndex"
            type="card"
            closable
            @tab-click="tabClick"
            @tab-remove="tabRemove"
          >
            <el-tab-pane
              v-for="item in pageTabs"
              :key="item.route"
              :label="item.meta.title"
              :name="item.route"
            />
          </el-tabs>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main class="main-content">
        <transition name="slide-fade" mode="out-in">
          <keep-alive :include="cachedPageNames" :max="6">
            <router-view />
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import screenfull from 'screenfull'
import MenuItem from './MenuItem.vue'

export default {
  name: 'Main',
  components: { MenuItem },

  data() {
    return {
      adminer: '',
      iscollapse: false,
      userHead: ''
    }
  },

  computed: {
    cachedPageNames() {
      return this.$store.state.app.cachedPageNames
    },
    pageTabs() {
      return this.$store.state.app.pageTabs
    },
    activeIndex: {
      get() {
        return this.$store.state.app.activeIndex
      },
      set(val) {
        this.$store.commit('set_active_index', val)
      }
    },
    menus() {
      return this.$store.state.app.menus
    },
    breadcrumbs() {
      const matched = this.$route.matched || []
      return matched
        .filter(r => r.meta && r.meta.title)
        .map(r => ({
          path: r.path || r.redirect || '/',
          name: r.name,
          meta: r.meta
        }))
    }
  },

  watch: {
    $route(to) {
      const exists = this.pageTabs.some(tab => tab.route === to.path)
      if (!exists) {
        this.$store.commit('add_tabs', {
          route: to.path,
          name: to.name,
          meta: to.meta,
          query: to.query
        })
        this.$store.commit('addCachedPage', { name: to.name, meta: to.meta })
      }
      this.$store.commit('set_active_index', to.path)
    }
  },

  mounted() {
    this.adminer = sessionStorage.getItem('adminer') || ''
    this.userHead = sessionStorage.getItem('userHead') || ''

    this.$util.get('user_permissions').then(res => {
      window.sessionStorage.setItem('roles', res.permissions)
      this.$store.commit('set_permssions', res.permissions)
      this.$store.commit('set_menus', res.menus)
    })

    // 初始化当前路由页签
    if (this.$route.path !== '/index' && this.$route.path !== '/') {
      this.addCurrentTab()
    }
  },

  methods: {
    addCurrentTab() {
      const tab = {
        route: this.$route.path,
        name: this.$route.name,
        meta: this.$route.meta,
        query: this.$route.query
      }
      const exists = this.pageTabs.some(t => t.route === tab.route)
      if (!exists) {
        this.$store.commit('set_active_index', this.$route.path)
        this.$store.commit('add_tabs', tab)
        this.$store.commit('addCachedPage', tab)
      }
    },

    toggleCollapse() {
      this.iscollapse = !this.iscollapse
    },

    tabClick() {
      if (this.$route.path !== this.activeIndex) {
        this.$router.replace({ path: this.activeIndex })
      }
    },

    tabRemove(targetName) {
      if (targetName === '/index') return

      const target = this.pageTabs.find(t => t.route === targetName)
      if (target) {
        this.$store.commit('delCachedPage', target)
      }
      this.$store.commit('delete_tabs', targetName)

      if (this.activeIndex === targetName) {
        if (this.pageTabs.length) {
          const last = this.pageTabs[this.pageTabs.length - 1]
          this.$store.commit('set_active_index', last.route)
          this.$router.replace({ path: last.route })
        } else {
          this.$router.replace({ path: '/index' })
        }
      }
    },

    logout() {
      ['token', 'roles', 'adminer', 'sex'].forEach(k =>
        window.sessionStorage.removeItem(k)
      )
      this.$store.commit('set_active_index', '/index')
      this.$router.push('/login')
    },

    extend() {
      if (!screenfull.isEnabled) {
        this.$message.error('当前不支持全屏')
        return
      }
      screenfull.toggle()
    },

    toLarge() {
      this.navigateFull('/large-screen')
    },

    toCarLarge() {
      this.navigateFull('/car-statistics')
    },

    navigateFull(path) {
      const el = document.documentElement
      if (el.requestFullscreen) {
        el.requestFullscreen()
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen()
      }
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
/* ==================== 布局 ==================== */
.main-container {
  height: 100vh;
  overflow: hidden;
}

/* ==================== 侧边栏 ==================== */
.sidebar {
  background-color: #001529;
  display: flex;
  flex-direction: column;
  transition: width 0.28s ease;
  overflow: hidden;
}

/* 品牌区 */
.sidebar-brand {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  flex-shrink: 0;
}

.brand-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: linear-gradient(135deg, #1890ff, #096dd9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.brand-icon i {
  font-size: 18px;
  color: #fff;
}

.brand-title {
  margin: 0 0 0 10px;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  letter-spacing: 1px;
}

/* 用户区 */
.sidebar-user {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  flex-shrink: 0;
  cursor: default;
}

.user-avatar {
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: border-color 0.3s;
}

.sidebar-user:hover .user-avatar {
  border-color: rgba(255, 255, 255, 0.5);
}

.user-detail {
  margin-left: 10px;
  overflow: hidden;
  white-space: nowrap;
}

.user-name {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  font-weight: 500;
}

/* 分割线 */
.sidebar-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 0 16px;
  flex-shrink: 0;
}

/* 菜单滚动区 */
.sidebar-menu-wrap {
  flex: 1;
  overflow: hidden;
}

.sidebar-menu-wrap /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.sidebar-menu-wrap /deep/ .el-scrollbar__view {
  padding: 8px 0;
}

/* 菜单样式覆盖 */
.sidebar /deep/ .el-menu {
  border-right: none;
}

.sidebar /deep/ .el-menu-item,
.sidebar /deep/ .el-submenu__title {
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  transition: all 0.3s;
}

.sidebar /deep/ .el-menu-item:hover,
.sidebar /deep/ .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #fff !important;
}

.sidebar /deep/ .el-menu-item.is-active {
  background: linear-gradient(90deg, #1890ff, transparent) !important;
  color: #fff !important;
  border-radius: 0 4px 4px 0;
  margin-right: 8px;
}

.sidebar /deep/ .el-menu-item i,
.sidebar /deep/ .el-submenu__title i {
  margin-right: 8px;
  font-size: 16px;
  width: 16px;
  text-align: center;
  color: inherit;
}

/* 折叠时菜单项居中 */
.sidebar /deep/ .el-menu--collapse .el-menu-item,
.sidebar /deep/ .el-menu--collapse .el-submenu__title {
  padding: 0 !important;
  text-align: center;
}

.sidebar /deep/ .el-menu--collapse .el-menu-item i,
.sidebar /deep/ .el-menu--collapse .el-submenu__title i {
  margin-right: 0;
}

/* 折叠切换 */
.sidebar-toggle {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.45);
  font-size: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
  transition: all 0.3s;
  user-select: none;
}

.sidebar-toggle:hover {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.04);
}

.toggle-right {
  justify-content: flex-end;
  padding-right: 16px;
}

/* ==================== 右侧主体 ==================== */
.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f0f2f5;
}

/* ==================== 顶栏 ==================== */
.main-header {
  padding: 0;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  z-index: 10;
}

.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 20px;
}

.header-breadcrumb {
  flex: 1;
  font-size: 14px;
  min-width: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 16px;
  flex-shrink: 0;
}

.action-btn {
  background: transparent !important;
  color: #595959 !important;
  border: none !important;
  font-size: 16px !important;
  transition: all 0.3s;
}

.action-btn:hover {
  color: #1890ff !important;
  background: rgba(24, 144, 255, 0.08) !important;
}

.logout-btn:hover {
  color: #ff4d4f !important;
  background: rgba(255, 77, 79, 0.08) !important;
}

.header-bar /deep/ .el-divider--vertical {
  height: 20px;
  margin: 0 4px;
}

/* ==================== 页签 ==================== */
.header-tabs {
  padding: 0 16px;
}

.header-tabs /deep/ .el-tabs__header {
  margin-bottom: 0;
}

.header-tabs /deep/ .el-tabs__nav-wrap::after {
  display: none;
}

.header-tabs /deep/ .el-tabs__item {
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  border: none !important;
  border-radius: 4px 4px 0 0;
  margin-right: 2px;
  color: #595959;
}

.header-tabs /deep/ .el-tabs__item.is-active {
  color: #1890ff;
  background: #f0f2f5;
}

.header-tabs /deep/ .el-tabs__item:hover {
  color: #1890ff;
}

.header-tabs /deep/ .el-tabs__content {
  display: none;
}

/* ==================== 内容区 ==================== */
.main-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background: #f0f2f5;
}

/* ==================== 过渡动画 ==================== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-8px);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter {
  opacity: 0;
  transform: translateX(-12px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(12px);
}

/* 面包屑过渡 */
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.breadcrumb-enter,
.breadcrumb-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
